<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <span class="title">{{ $t("admin.toolbox.toolbox_title") }}</span>

            <button v-bind:class="mapBackgroundGeneratorButtonClass">{{ $t("admin.toolbox.map_background_generator") }}</button>
        </div>

        <div class="toolbox-container shadow-sm">
            <MapBackgroundGeneratorTool v-if="selectedTool == 'mapBackgroundGenerator'" />
        </div>
    </div>
</template>

<script>
import MapBackgroundGeneratorTool from "./MapBackgroundGeneratorTool"

export default {
    components: {
        MapBackgroundGeneratorTool
    },

    data() {
        return {
            selectedTool: "mapBackgroundGenerator"
        }
    },

    computed: {
        mapBackgroundGeneratorButtonClass() {
            return "btn btn-outline-primary btn-sm" + (this.selectedTool == "mapBackgroundGenerator" ? " active": "");
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 16px;
    width: 100%;
    max-width: none;
    text-align: left;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.toolbar button {
    margin: 0px 4px;
}

.toolbox-container {
    background-color: #ffffff;
    margin: 0 auto;
    overflow: scroll;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;
}

.tools-list {
    list-style: none;
}

</style>